import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import checkMarkIconWhite from 'assets/icons/checkmark-white.svg';
import IconProtectionPlan from 'components/icons/iconProtectionPlan';
import IconPetProtector from 'components/icons/iconPetProtector';
import JBImage from 'components/essentials/JBImage';
const ListItem = desc => {
  const $ = _c(5);
  let theDesc = desc;
  let t0;
  if ($[0] !== theDesc.replace) {
    t0 = theDesc.replace("<strong>", "").replace("</strong>", "");
    $[0] = theDesc.replace;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  theDesc = t0;
  let t1;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <JBImage className="check" src={checkMarkIconWhite} width={16} alt="check" />;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== theDesc) {
    t2 = <li>{t1}<span>{theDesc}</span></li>;
    $[3] = theDesc;
    $[4] = t2;
  } else {
    t2 = $[4];
  }
  return t2;
};
const ProtectionPlanVariant = t0 => {
  const $ = _c(22);
  const {
    backgroundImg: t1,
    planType: t2,
    planItems: t3,
    planName: t4
  } = t0;
  const backgroundImg = t1 === undefined ? "" : t1;
  const planType = t2 === undefined ? "protection" : t2;
  let t5;
  if ($[0] !== t3) {
    t5 = t3 === undefined ? [] : t3;
    $[0] = t3;
    $[1] = t5;
  } else {
    t5 = $[1];
  }
  const planItems = t5;
  const planName = t4 === undefined ? "" : t4;
  const t6 = backgroundImg ? `url(${backgroundImg})` : null;
  let t7;
  if ($[2] !== t6) {
    t7 = {
      backgroundImage: t6
    };
    $[2] = t6;
    $[3] = t7;
  } else {
    t7 = $[3];
  }
  let t8;
  if ($[4] !== planType) {
    t8 = <div className="[&_svg]:fill-brand-dark">{planType === "pet" ? <IconPetProtector /> : <IconProtectionPlan circleFill="#016a78" fill="#fff" />}</div>;
    $[4] = planType;
    $[5] = t8;
  } else {
    t8 = $[5];
  }
  let t10;
  let t9;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <span className="text-xl font-bold w-full tracking-[.2px] md:text-2xl md:font-bold">5-year Protection Plan</span>;
    t10 = <span className="text-base font-bold mb-2 md:text-[.8rem]">When an accident happens, know your investment is protected.</span>;
    $[6] = t10;
    $[7] = t9;
  } else {
    t10 = $[6];
    t9 = $[7];
  }
  let t11;
  if ($[8] !== planName) {
    t11 = <span className="text-lg font-bold">{planName}</span>;
    $[8] = planName;
    $[9] = t11;
  } else {
    t11 = $[9];
  }
  let t12;
  if ($[10] !== planItems) {
    t12 = planItems.map(_temp);
    $[10] = planItems;
    $[11] = t12;
  } else {
    t12 = $[11];
  }
  let t13;
  if ($[12] !== t12) {
    t13 = <ul>{t12}</ul>;
    $[12] = t12;
    $[13] = t13;
  } else {
    t13 = $[13];
  }
  let t14;
  if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
    t14 = <span className="text-sm font-bold">In partnership with ServeCo.</span>;
    $[14] = t14;
  } else {
    t14 = $[14];
  }
  let t15;
  if ($[15] !== t11 || $[16] !== t13 || $[17] !== t8) {
    t15 = <div className="ProtectionPlanVariant__protection-plan">{t8}{t9}{t10}{t11}{t13}{t14}</div>;
    $[15] = t11;
    $[16] = t13;
    $[17] = t8;
    $[18] = t15;
  } else {
    t15 = $[18];
  }
  let t16;
  if ($[19] !== t15 || $[20] !== t7) {
    t16 = <div className="text-base text-white bg-brand-dark [background-image:url(https://joybird2.imgix.net/user-uploads-staging/joybird-teal-new.jpg?w=400&cs=srgb)] bg-cover p-4 text-left flex flex-col font-bold [&_span]:block [&_ul]:mt-4 [&_ul]:mx-0 [&_ul]:mb-0 [&_ul]:min-h-[9rem] [&_ul_li]:text-base [&_ul_li]:flex [&_ul_li]:pb-[.15rem] [&_ul_li]:list-none [&_ul_li_img]:pr-[.2rem] [&_ul_li_img]:mr-[.325rem]" style={t7}>{t15}</div>;
    $[19] = t15;
    $[20] = t7;
    $[21] = t16;
  } else {
    t16 = $[21];
  }
  return t16;
};
ProtectionPlanVariant.propTypes = {
  backgroundImg: PropTypes.string,
  planType: PropTypes.string,
  planItems: PropTypes.array,
  planName: PropTypes.string
};
export default ProtectionPlanVariant;
function _temp(desc) {
  return <ListItem key={desc} desc={desc} />;
}